<template>
  <div class="out-div">
    <div class="plan-filter">
      <span class="filter-title">仓库</span>
      <el-select v-model="town_id" placeholder="请选择仓库" v-loadMore="loadMoreTownData" @change="changeTown">
        <el-option :label="item.town_name" :value="item.town_id" v-for="(item, index) in townList" :key="index"></el-option>
      </el-select>
    </div>
    <div class="equ-main animated fadeInUp">
      <div class="row-out" v-if="equipmentName != 'grow'">
        <div class="row-one-data">
          <span>设备状态：</span>
          <div class="status" :class="online == 1 ? '' : 'active'">
            <span>{{ online == 1 ? '在线' : '离线' }}</span>
          </div>
        </div>
      </div>
      <div class="outer">
        <page-left
          :btnShow="false"
          :config="pageLeftConfig"
          :lists="allDataList"
          @changeItems="changeItems"
          v-show="equipmentName !== 'shuifei'"
        ></page-left>
        <div :class="['row-data']">
          <div
            class="items-lists"
            :class="{
              active_chongqing: equipmentName === 'insect'
            }"
            v-show="nowTitle !== 'insect-quantity' && nowTitle !== 'insect-img' && equipmentName !== 'grow' && equipmentName !== 'shuifei'"
          >
            <div v-for="t in dataList" :key="t.id" :style="{ 'background-color': t.color }" class="data-items">
              <div class="div-Type0">
                <div :class="['status', t.online == 1 ? '' : 'active']">
                  <div class="yuan"></div>
                  <span v-if="t.online == 1" class="zaixian">在线</span>
                  <span v-else class="lixian">离线</span>
                </div>
                <img class="iconImg" v-if="t.alias" :src="$imgOnlineUrl + '/equipment/chemical/' + t.alias + '.png'" />
                <div class="otherInfo" @click="showLog(t.id)">
                  <div class="num" v-if="typeof t.last_data == 'number'">
                    <VueCountUp
                      class="count-up"
                      :start-value="0"
                      :end-value="t.last_data"
                      :duration="1"
                      :decimals="String(t.last_data).indexOf('.') + 1 > 1 ? '1' : '0'"
                    />
                    <span :class="['company']">{{ t.data_unit }}</span>
                  </div>
                  <div class="num" v-else>
                    <span class="count-up">{{ t.last_data }}</span>
                    <span class="company">{{ t.data_unit }}</span>
                  </div>
                  <span :class="['msg']">{{ t.title }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="drying-box">
            <div class="drying-items" v-for="(item, index) in dryingList" :key="index">
              <img class="jiare" src="../../assets/image/drying/jiare.png" />
              <div :class="['status-box', item.status ? 'active' : '']"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      class="big-pop"
      title=" "
      :visible.sync="isLogShow"
      width="673px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="setAddClose"
    >
      <div class="big-main">
        <div class="ware-title">
          <div class="left-line"></div>
          历史记录
        </div>
        <div class="add-form">
          <div class="per-class">
            <span>选择日期</span>
            <el-date-picker class="my-date-picker" v-model="dateTime" :clearable="false" type="date" placeholder="选择日期" @change="changeDate">
            </el-date-picker>
          </div>
          <v-chart class="v-chart" autoresize :option="line_chart_data"></v-chart>
          <div class="per-class">
            <el-date-picker
              class="my-date-picker"
              v-model="rangeTime"
              :clearable="false"
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
            <el-button type="primary" class="btn" @click="exportData">数据导出</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <My-analyse :isAnalyseShow="isAnalyseShow" :info="info" @beforeClose="beforeClose" />
  </div>
</template>

<script>
import {
  getEquipmentListApi,
  getEquipmentInfoApi,
  getEquipmentChildListApi,
  setEquipmentChildInfoApi,
  getEquipmentChildListInfoApi
} from '@/request/api'
import VueCountUp from 'vue-countupjs'
import { mapState, mapMutations } from 'vuex'

import { TitleComponent, TooltipComponent, LegendComponent, GridComponent } from 'echarts/components'
import VChart, { THEME_KEY } from 'vue-echarts'
import { use } from 'echarts/core'
import { PieChart, BarChart, LineChart } from 'echarts/charts'
import { LabelLayout, UniversalTransition } from 'echarts/features'
import { CanvasRenderer } from 'echarts/renderers'
import moment from 'moment'
use([
  BarChart,
  CanvasRenderer,
  PieChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  LineChart,
  LabelLayout,
  UniversalTransition
])
export default {
  components: {
    VueCountUp,
    VChart,
    pageLeft: () => import('../../views/equipment/component/pageLeft.vue'),
    MyAnalyse: () => import('@/components/MyAnalyse.vue')
  },
  provide: {
    [THEME_KEY]: 'dark'
  },
  data() {
    return {
      dryingList: [
        {
          status: 1
        },
        {
          status: 0
        },
        {
          status: 1
        },
        {
          status: 1
        },
        {
          status: 0
        },
        {
          status: 1
        },
        {
          status: 1
        },
        {
          status: 1
        }
      ],
      picOption: {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: '5%',
          left: 'center'
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: 'transparent',
              borderWidth: 2
            },
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 40,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: []
          }
        ]
      },
      videoMoveList: [
        {
          title: '光学放大',
          direction: 8
        },
        {
          title: '光学缩小',
          direction: 9
        }
      ],
      growMainShow: true,
      isAnalyseShow: false,
      info: {},
      chongqingTabShow: 'insect',
      identifyList: [],
      identifyTime: [],
      identifyChartTime: [],
      rangeTime: '',
      dateTime: null,
      isLogShow: false,
      line_chart_data: {
        backgroundColor: '#0F243D',
        xAxis: {
          type: 'category',
          data: [],
          boundaryGap: false,
          interval: 55
        },
        yAxis: {
          name: '',
          nameLocation: 'end',
          nameGap: 14,
          nameTextStyle: {
            color: '#fff',
            fontSize: 12,
            padding: [0, 0, 0, 30]
          },

          type: 'value',
          splitNumber: 6
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: '#36B77F',
          borderColor: '#36B77F',
          padding: [7, 12],
          formatter: '时间：{b}<br/> 数值：{c}',
          textStyle: {
            color: '#fff'
          }
        },
        series: [
          {
            type: 'line',
            data: [],
            smooth: true,
            showSymbol: false,
            lineStyle: {
              color: 'rgb(54,183,127)',
              width: 2
            },
            itemStyle: {
              borderWidth: 2,
              borderColor: '#36B77F',
              color: '#fff'
            },
            areaStyle: {
              color: 'rgba(54,183,127,.28)'
            }
          }
        ]
      },
      pageLeftConfig: {
        placeholder: '搜索设备名称',
        img: this.$imgOnlineUrl + '/equipment/meteorological/icon5.png'
      },
      switchValue: true,
      switchTxt: '',
      editCount: '',
      isEditShow: undefined,
      colorList: ['#3679FC', '#9D60B5', '#0FB4BA', '#91CB74', '#EE6666', '#35BFFE', '#F0934D', '#6E71EE', '#A8BBA3', '#A8BBA3'],
      channel_id: '',
      table_id: '',
      nowTable_id: '',
      nowTitle: '',
      child_id: '',
      online: 1,
      data_value: '',
      data_type: '',
      allDataList: [],
      dataList: [],

      isRotate: false,
      clearT: null
    }
  },
  watch: {
    '$route.query'(newVal) {
      this.channel_id = newVal
      this.dataList = []
      this.getEquipmentList()
    }
  },
  beforeDestroy() {
    if (this.clearT) {
      clearTimeout(this.clearT)
      this.clearT = null
    }
  },
  computed: {
    ...mapState({
      farmID: (state) => state.user.farmID,
      equipmentName: (state) => state.user.equipmentName
    })
  },
  created() {
    this.getEquipmentList()
  },
  methods: {
    ...mapMutations('user', ['SET_EQUIPMENT_Name']),

    beforeClose() {
      this.isAnalyseShow = false
      this.info = {}
    },
    analyseShow(t) {
      this.isAnalyseShow = true
      this.info = t
    },
    changeItems(table_id) {
      this.identifyList = []
      this.nowTable_id = table_id.id
      this.nowTitle = table_id.alias
      this.getEquipmentChildList(table_id.id)
    },
    showLog(id) {
      this.dateTime = moment(new Date()).format('YYYY-MM-DD')
      this.isLogShow = true
      this.child_id = id
      this.changeDate()
    },
    async changeDate() {
      let day = moment(this.dateTime).format('YYYY-MM-DD')
      const res = await getEquipmentChildListInfoApi({
        manor_id: +this.farmID,
        table_id: this.nowTable_id,
        child_id: this.child_id,
        day,
        end_day: day,
        act: 'history'
      })
      if (res.code == 0) {
        this.line_chart_data['xAxis']['data'] = []
        this.line_chart_data['series'][0]['data'] = []
        res.results.data.forEach((a) => {
          let date = new Date(a['x'])
          let h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
          let xAxis = h + ':' + date.getMinutes()
          this.line_chart_data['xAxis']['data'].push(xAxis)
          this.line_chart_data['series'][0]['data'].push(a['y'])
        })
        this.line_chart_data['yAxis']['name'] = res.view.title + res.view.data_unit
      }
    },
    async getIdentifyList(day, end_day) {
      const res = await getEquipmentInfoApi({
        manor_id: +this.farmID,
        table_id: this.nowTable_id,
        day,
        end_day,
        act: 'status'
      })
      if (res.code === 0) {
        this.identifyList = res.results.data
      }
    },
    async getIdentifyChartList(day, end_day) {
      this.picOption.series[0].data = []

      const res = await getEquipmentInfoApi({
        manor_id: +this.farmID,
        table_id: this.nowTable_id,
        day,
        end_day,
        act: 'status'
      })
      if (res.code === 0) {
        let item = {}
        for (let i = 0; i < res.results.data.length; i++) {
          item[res.results.data[i].name] = ~~item[res.results.data[i].name] + res.results.data[i].num
        }
        let keys = Object.keys(item)
        let values = Object.values(item)
        for (let k = 0; k < keys.length; k++) {
          let obj = {}
          obj.name = keys[k]
          obj.value = values[k]
          this.picOption.series[0].data.push(obj)
        }
      }
    },
    async exportData() {
      if (!this.rangeTime) {
        this.$notify.error({
          title: '错误',
          message: '请选择日期范围'
        })
        return
      }
      let day = moment(this.rangeTime[0]).format('YYYY-MM-DD')
      let end_day = moment(this.rangeTime[1]).format('YYYY-MM-DD')
      const res = await getEquipmentChildListInfoApi({
        manor_id: +this.farmID,
        table_id: this.allDataList[0].id,
        child_id: this.child_id,
        day,
        end_day,
        act: 'history'
      })
      if (res.code === 0) {
        let str = `时间,数值\n`
        for (let a of res.results.data) {
          let date = new Date(a.x)
          let x = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes()
          str += x + '\t,' + a.y + '\n'
        }
        let uri = 'data:text/csv;charset=utf-8,\ufeff' + encodeURIComponent(str)
        let link = document.createElement('a')
        link.href = uri
        link.download = this.line_chart_data['yAxis']['name'] + '[' + day + ' 至 ' + end_day + ']数据.csv'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    },
    setAddClose() {
      this.isLogShow = false
      this.dateTime = ''
      this.rangeTime = ''
      this.line_chart_data['xAxis']['data'] = []
      this.line_chart_data['series'][0]['data'] = []
      this.line_chart_data['yAxis']['name'] = ''
    },
    blur(e, id) {
      this.child_id = id
      this.data_type = 2
      this.data_value = e.target._value
      this.setEquipmentChildInfo()
      this.isEditShow = undefined
    },
    handleClick(tab) {
      this.chongqingTabShow = tab.name
    },
    editNum(i) {
      this.isEditShow = i
    },
    changeSwitch(e, id) {
      this.child_id = id
      this.data_type = 1
      this.data_value = e
      this.switchTxt = e ? '开' : '关'
      this.setEquipmentChildInfo()
    },
    async setEquipmentChildInfo() {
      const { code, msg } = await setEquipmentChildInfoApi({
        manor_id: +this.farmID,
        table_id: this.nowTable_id,
        child_id: this.child_id, //子信息ID
        data_type: this.data_type, //数据类型：1交互，2数值
        data_value: this.data_value //交互类是0/1，数据类是实际值
      })
      if (code === 0) {
        this.$notify({
          title: '成功',
          message: '已修改！',
          type: 'success'
        })
      } else {
        this.$notify({
          title: '提示',
          message: msg
        })
      }
    },
    async getEquipmentList() {
      this.channel_id = this.$route.query.id || localStorage.getItem('equipmentId')
      const { code, results } = await getEquipmentListApi({
        manor_id: +this.farmID,
        channel_id: this.channel_id
      })

      if (code === 0 && Array.isArray(results)) {
        this.allDataList = results
        this.nowTitle = this.allDataList[0].alias || ''

        this.nowTable_id = results[0].id
        this.getEquipmentChildList(this.allDataList[0].id)
      } else {
        this.allDataList = []
        this.dataList = []
      }
    },

    async getEquipmentInfoApi_status(table_id) {
      const { code, results } = await getEquipmentInfoApi({
        manor_id: +this.farmID,
        table_id,
        act: 'status'
      })
      if (code == 0) {
        this.online = results.online
        for (let key in this.dataList) {
          let data1 = this.dataList[key].number
          for (let keys in results.data) {
            if (results.data[keys].number == data1) {
              this.dataList[key].last_data = results.data[keys].last_data
              this.dataList[key].online = results.data[keys].online
            }
          }
        }
        this.$forceUpdate()
      }
    },
    async getEquipmentChildList(table_id) {
      const { code, results } = await getEquipmentChildListApi({
        manor_id: +this.farmID,
        table_id
      })
      if (code === 0 && results) {
        this.colorList.forEach((item, index) => {
          if (results[index]) {
            results[index]['color'] = item
          }
        })
        this.dataList = results
        this.getEquipmentInfoApi_status(table_id)
      }
    },
    editTime(index) {
      this.isEditShow = index
    },
    openTime() {
      this.isEditShow = null
    },
    closeTime() {
      this.isEditShow = null
    }
  }
}
</script>

<style lang="less" scoped>
@keyframes imgRotate {
  0% {
    transform: rotate(0);
  }

  100% {
    transform: rotate(180deg);
  }
}
.out-div {
  padding: 0 48px;
  .plan-filter {
    display: flex;
    align-items: center;
    .filter-title {
      margin-right: 10px;
      font-size: 14px;
      font-weight: 400;
      color: #fff;
    }
    .village-p {
      height: 100%;
      width: 240px;
      padding: 10px 0;
      span {
        font-size: 14px;
        font-weight: 400;
        color: #ccc;
        margin-right: 4px;
      }
    }
    /deep/.el-select {
      width: 180px;
      height: 40px;
      border-radius: 3px;
      margin-right: 25px;
      .el-input__inner {
        border: 1px solid #385576;
        color: #fff;
        background: #081c30;
      }
    }
    .filter-main {
      min-width: 39px;
      max-width: 74px;
      height: 40px;
      background: #15589d;
      border-radius: 3px;
      font-size: 14px;
      font-weight: 400;
      color: #fff;
      line-height: 40px;
      padding: 0 16px;
      margin-right: 25px;
      text-align: center;
      &.nomargin {
        margin-right: 0;
      }
    }
  }
  .equ-main {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 22px 0px 20px;
    .row-out {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;

      .row-one-data {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        .status {
          display: block;
          width: 55px;
          height: 15px;
          color: chartreuse;
          display: flex;
          align-items: center;

          &::before {
            content: '';
            display: block;
            width: 5px;
            height: 5px;
            border-radius: 50%;
            background-color: chartreuse;
            margin-right: 6px;
          }
          &.active {
            color: brown;
          }
          &.active::before {
            background-color: brown;
          }
        }
      }
      .log {
        width: 70px;
        height: 12px;
        color: #fff;
        cursor: pointer;
      }
    }
    .outer {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: #071a2c;

      .row-data {
        flex: 1;
        height: 800px;
        background: #0e2138;
        position: relative;

        /deep/.my-tabs {
          padding: 0 20px;
          .el-tabs__item {
            color: #fff;
          }
        }
        .identify {
          width: 100%;
          display: flex;
          height: 800px;
          flex-direction: column;
          padding: 20px;
          overflow-y: auto;

          &::-webkit-scrollbar {
            width: 5px;
          }
          &::-webkit-scrollbar-thumb {
            border-radius: 10px;
            background-color: #3e90e5;
          }
          /deep/.identify-per-class {
            color: #fff;
            margin-bottom: 20px;
            span {
              margin-right: 20px;
            }
            .el-input__inner {
              background-color: #081c30;
              border-color: #385576;
              .el-range-input {
                background-color: #081c30;
              }
            }
            .el-range-separator {
              color: #fff;
            }
          }
          .identify-list {
            width: 100%;
            display: flex;
            flex-wrap: wrap;

            .identify-list-item {
              width: 240px;
              height: 220px;
              margin: 0 20px 20px 0;
              display: flex;
              flex-direction: column;
              background-color: #0e2f53;
              .imgs {
                width: 100%;
                height: 180px;
              }
              .bottom-row {
                width: 100%;
                height: 40px;
                font-size: 14px;
                padding: 12px 8px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                color: #fff;
                .analyse {
                  cursor: pointer;
                  &:hover {
                    text-decoration: underline;
                  }
                }
              }
            }
          }
        }

        .items-lists {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          padding: 20px;
          position: relative;
          z-index: 100;
          .data-items {
            height: 120px;
            min-width: 246px;
            border-radius: 5px;
            margin: 0 16px 20px 0;
            display: flex;
            align-items: center;
            justify-content: center;

            .div-Type0 {
              width: 100%;
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              position: relative;
              .status {
                width: 50px;
                height: 20px;
                border-radius: 40px;
                background-color: rgba(0, 0, 0, 0.3);
                position: absolute;
                top: 8px;
                right: 8px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 12px;
                .zaixian {
                  color: chartreuse;
                }
                .lixian {
                  color: red;
                }
                .yuan {
                  width: 8px;
                  height: 8px;
                  background-color: chartreuse;
                  border-radius: 50%;
                  margin: 0 4px 0 0;
                }
                &.active {
                  color: red;
                  .yuan {
                    background-color: red;
                  }
                }
              }
              .iconImg {
                width: 74px;
                height: 74px;
                margin-right: 14px;
              }
              .otherInfo {
                flex: 1;
                .num {
                  margin-bottom: 12px;
                  .count-up,
                  .company {
                    font-size: 30px;
                    font-weight: bold;
                    color: #fff;
                  }
                }
                .msg {
                  font-size: 16px;
                  color: #fff;
                }
              }
            }
            .div-Type0 {
              padding: 0 20px;
              cursor: pointer;
            }
          }
        }
        .drying-box {
          width: 100%;
          display: flex;
          padding: 20px;
          justify-content: space-around;
          .drying-items {
            width: 140px;
            position: relative;
            .jiare {
              width: 100%;
            }
            .status-box {
              width: 6px;
              height: 6px;
              border-radius: 50%;
              position: absolute;
              bottom: 70px;
              left: 76px;
              background-color: red;

              &.active {
                left: 100px;
                background-color: chartreuse;
              }
            }
          }
        }
      }
    }

    .other {
      width: 100%;
      display: flex;
      flex-wrap: wrap;

      .electric,
      .tap,
      .time {
        width: 352px;
        min-height: 599px;
        background: #081c30;
        margin-right: 15px;
        display: flex;
        flex-direction: column;
        padding: 27px 23px;
        justify-content: space-between;

        .title {
          display: flex;
          align-items: center;
          margin-bottom: 33px;

          img {
            width: 28px;
            height: 28px;
            margin-right: 11px;
          }

          span {
            font-size: 22px;
            color: #fff;
          }
        }

        .main {
          width: 100%;
          flex: 1;
          display: flex;
          flex-direction: column;

          .main-items {
            width: 100%;
            display: flex;
            align-items: center;
            padding: 0 25px;
            height: 38px;
            margin-bottom: 18px;
            background: #0e2f53;
            justify-content: space-between;

            .main-msg {
              font-size: 14px;
              color: #fff;
            }
          }
        }

        .update-time {
          width: 100%;
          text-align: center;
          font-size: 14px;
          color: #99b7d9;
        }
      }
      .tap {
        width: 996px;

        .tap-main {
          width: 100%;
          flex: 1;
          display: flex;
          flex-wrap: wrap;

          .main {
            margin-right: 26px;
            width: 31.33%;
            height: auto;
            flex: none;
            &:nth-of-type(3n) {
              margin-right: 0px;
            }
          }
        }
      }

      .time {
        margin-right: 0;

        .time-main {
          .main-items {
            .num-box {
              span {
                font-size: 14px;
                color: #fff;
              }

              input {
                width: 81px;
                height: 26px;
                background: #081c30;
                border: 1px solid #385576;
                font-size: 14px;
                color: #fff;
                padding: 0 0 0 7px;
              }
            }

            .icon-box {
              display: flex;
              justify-content: flex-end;

              img {
                margin-right: 2px;
                width: 18px;
                cursor: pointer;
                height: 18px;
              }

              img.edit-imgs {
                margin-right: 0;
              }
            }
          }
        }
      }
    }
  }

  .big-pop {
    /deep/.el-dialog {
      width: 673px !important;
      background-color: inherit;
      margin-top: 0 !important;

      .el-dialog__header {
        padding: 16px 20px 10px;
      }
    }

    /deep/.el-dialog__body {
      padding: 0;
    }

    /deep/.el-dialog__headerbtn {
      font-size: 26px;
      top: 71px;
      right: 52px;
      font-weight: bold;
    }

    /deep/.el-button span {
      color: #fff;
    }

    /deep/.dialog-footer {
      padding: 0 0 0 119px;

      .el-form-item__content {
        width: 353px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }

    .ok-button {
      width: 150px;
      height: 40px;
      margin-right: 44px;
    }

    .no-button {
      width: 150px;
      height: 40px;
      border: 1px solid #385576;
      background-color: #0f243d;
    }

    .big-main {
      width: 673px;
      height: 861px;
      background: url('../../assets/image/task/popbgc.png') no-repeat center center;
      background-size: cover;
      padding: 45px 55px 0 55px;

      .ware-title {
        font-size: 22px;
        color: #fff;
        font-weight: bold;
        display: flex;
        margin-bottom: 40px;

        .left-line {
          background-color: #fff;
          width: 4px;
          height: 21px;
          border-radius: 3px;
          margin-right: 10px;
        }
      }
      .add-form {
        display: flex;
        flex-direction: column;
        width: 100%;
        overflow-y: scroll;
        height: calc(100% - 150px);

        &::-webkit-scrollbar {
          width: 7px;
        }

        &::-webkit-scrollbar-thumb {
          border-radius: 10px;
          background-color: #3e90e5;
        }
        .per-class {
          color: #fff;
          margin-bottom: 20px;
          span {
            margin-right: 20px;
          }
          .btn {
            margin-left: 20px;
          }
        }

        .v-chart {
          width: 100%;
          height: 500px;
        }
      }

      /deep/.el-input__inner {
        background-color: #081c30;
        border: 1px solid #385576;
        color: #57708d;
        width: 353px;
      }

      /deep/.el-form-item__label {
        font-size: 14px;
        color: #fff;
        padding: 0 24px 0 0;
      }

      /deep/.el-date-editor--datetimerange.el-input,
      /deep/.el-date-editor--datetimerange.el-input__inner {
        width: 353px;
      }

      /deep/.el-input__inner {
        background-color: #081c30;
        border-color: #385576;
      }

      /deep/.el-date-editor .el-range-input {
        background-color: #081c30;
        color: #57708d;
        width: 44%;
      }

      /deep/.el-date-editor .el-range-separator {
        color: #fff;
      }

      /deep/.type .el-input__inner {
        width: 136px;
      }

      /deep/.type .el-select {
        width: 136px;
        margin-right: 26px;
      }

      /deep/.type .el-form-item__content {
        display: flex;
      }

      /deep/.type .el-select:nth-of-type(2) {
        margin-right: 0px;
      }

      /deep/.type-col.el-form-item.type {
        display: flex;
        .el-form-item__content {
          margin-left: 0 !important;
        }
      }

      /deep/.detail-form,
      /deep/.complete-form {
        .el-form-item__content {
          p {
            color: #fff;
          }
        }
      }

      /deep/.detail-form {
        .el-form-item {
          margin-bottom: 15px;
        }

        .el-form-item__label,
        .el-form-item__content {
          line-height: 30px;
        }
      }
    }
  }
}
</style>
